import React, { useEffect } from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";

import Loader from "components/commons/Loader/Loader";
import {observer} from "mobx-react-lite";
import BenefitDetailForm from "components/BenefitManagementComponents/BenefitDetailForm/BenefitDetailForm";
import BenefitManagementStore from "stores/BenefitsManagementStore";

const BenefitDetailRoute: React.FC<RouteComponentProps<{ id: string; }>> = (
  {
    match: {
      params: { id }
    },}
) => {
  const { benefit } = BenefitManagementStore;

  useEffect(() => {
    BenefitManagementStore.setBenefit(undefined);
    BenefitManagementStore.setBenefitId(id);
    BenefitManagementStore.getBenefit().catch(console.error);
  }, [id]);

  if (!benefit) {
    return <Loader />;
  }

  return (<BenefitDetailForm />)
};

export default withRouter(observer(BenefitDetailRoute));
